//===================================
// Fade in
//===================================

import { observeWhenInView } from '../utils';

let playing = [];

const FadeIn = (ele) => {
  const init = () => {
    observeWhenInView(ele, (isIntersecting, unobserve) => {
      if (isIntersecting) {
        play();
        unobserve();
      }
    });
  }

  const play = () => {
    playing.push(ele);

    setTimeout(() => {
      playing = playing.filter(i => i != ele);
      ele.classList.add('in');
    }, 150 * playing.length);
  }

  init();
}

document.addEventListener('DOMContentLoaded', () => {
  const eles = document.querySelectorAll('.fade-in');

  eles.forEach(ele => {
    FadeIn(ele);
  });
});